import { createContext } from 'react';

const SiteSettingsContext = createContext(void 0);

SiteSettingsContext.displayName = 'context(siteSettings)';

export default SiteSettingsContext;